import React from 'react';
import { Box, Typography } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { ContentContainer } from 'components/styles_components/container';
import { ChapterTypography } from 'components/styles_components/typography';

const Section = ({ titleId, children }) => (
  <Box sx={{ mb: 3 }}>
    <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
      <FormattedMessage id={titleId} />
    </Typography>
    {children}
  </Box>
);

const P = ({ id }) => (
  <Typography variant="body1" sx={{ mb: 1 }}>
    <FormattedMessage id={id} />
  </Typography>
);

const Li = ({ id }) => (
  <Typography variant="body1" component="li" sx={{ ml: 3, mb: 0.5 }}>
    <FormattedMessage id={id} />
  </Typography>
);

const Terms = () => {
  return (
    <ContentContainer maxWidth="md">
      <ChapterTypography variant="h5" align="center">
        <FormattedMessage id="legal.terms.title" />
      </ChapterTypography>
      <Typography variant="subtitle1" align="center" sx={{ mb: 4 }}>
        <FormattedMessage id="legal.terms.subtitle" />
      </Typography>

      <Section titleId="legal.terms.s1.title">
        <P id="legal.terms.s1.p1" />
        <P id="legal.terms.s1.p2" />
        <P id="legal.terms.s1.p3" />
        <P id="legal.terms.s1.p4" />
        <P id="legal.terms.s1.p5" />
      </Section>

      <Section titleId="legal.terms.s2.title">
        <P id="legal.terms.s2.p1" />
        <P id="legal.terms.s2.p2" />
        <P id="legal.terms.s2.p3" />
      </Section>

      <Section titleId="legal.terms.s3.title">
        <P id="legal.terms.s3.p1" />
        <P id="legal.terms.s3.p2" />
        <P id="legal.terms.s3.p3" />
      </Section>

      <Section titleId="legal.terms.s4.title">
        <P id="legal.terms.s4.p1" />
        <P id="legal.terms.s4.p2" />
      </Section>

      <Section titleId="legal.terms.s5.title">
        <P id="legal.terms.s5.p1" />
        <P id="legal.terms.s5.p2" />
        <ul>
          <Li id="legal.terms.s5.li1" />
          <Li id="legal.terms.s5.li2" />
          <Li id="legal.terms.s5.li3" />
          <Li id="legal.terms.s5.li4" />
        </ul>
        <P id="legal.terms.s5.p3" />
      </Section>

      <Section titleId="legal.terms.s6.title">
        <P id="legal.terms.s6.p1" />
        <P id="legal.terms.s6.p2" />
      </Section>

      <Section titleId="legal.terms.s7.title">
        <P id="legal.terms.s7.p1" />
        <P id="legal.terms.s7.p2" />
      </Section>

      <Section titleId="legal.terms.s8.title">
        <P id="legal.terms.s8.p1" />
        <P id="legal.terms.s8.p2" />
      </Section>

      <Section titleId="legal.terms.s9.title">
        <P id="legal.terms.s9.p1" />
        <P id="legal.terms.s9.p2" />
      </Section>

      <Section titleId="legal.terms.s10.title">
        <P id="legal.terms.s10.p1" />
      </Section>

      <Section titleId="legal.terms.s11.title">
        <P id="legal.terms.s11.p1" />
      </Section>

      <Section titleId="legal.terms.s12.title">
        <P id="legal.terms.s12.p1" />
        <ul>
          <Li id="legal.terms.s12.li1" />
          <Li id="legal.terms.s12.li2" />
        </ul>
        <P id="legal.terms.s12.p2" />
      </Section>

      <Section titleId="legal.terms.s13.title">
        <P id="legal.terms.s13.p1" />
        <P id="legal.terms.s13.p2" />
      </Section>

      <Section titleId="legal.terms.s14.title">
        <P id="legal.terms.s14.p1" />
        <P id="legal.terms.s14.p2" />
        <P id="legal.terms.s14.p3" />
      </Section>

      <Typography variant="body2" align="center" sx={{ mt: 4, color: 'text.secondary' }}>
        <FormattedMessage id="legal.trademark" />
      </Typography>
    </ContentContainer>
  );
};

export default Terms;
